import React, {Component} from 'react';

import axios from 'axios';

import Adsense from './_adsense.js';

import {
    ShareButtons,
    generateShareIcon
} from 'react-share';


const {
    FacebookShareButton,
    GooglePlusShareButton,
    TwitterShareButton,
} = ShareButtons;

const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');
const GooglePlusIcon = generateShareIcon('google');


class GetCalendar extends Component {

    constructor(props) {
        super(props);
        this.state = {isLoading: true};

        this.PageData = global.api.pagesData[this.props.type];

        try {
            document.title = this.PageData.title[global.api.CurrentLanguage];
        }
        catch (err) {
        }
    }

    componentDidMount() {
        try {
            axios.get(global.api.app + 'efs/' + this.PageData['data'][global.api.CurrentLanguage])
                .then(res => {
                    this.setState((prevState, props) => {
                        return {isLoading: false, data: res['data']};
                    });
                });
        }
        catch (err) {
        }
    }


    render() {

        if (this.state.isLoading === true) {
            return null;
        }


        const shareButton =
            <div style={{display: "flex"}}>
                <FacebookShareButton url={window.location.href }
                                     style={{margin: "7px"}}>
                    <FacebookIcon size={32} round/>
                </FacebookShareButton>

                <TwitterShareButton url={window.location.href }
                                    style={{margin: "7px"}}>
                    <TwitterIcon size={32} round/>
                </TwitterShareButton>

                <GooglePlusShareButton
                    url={window.location.href }
                    style={{margin: "7px"}}>
                    <GooglePlusIcon size={32} round/>
                </GooglePlusShareButton>
            </div>;


        const bannerTop = (
            <div style={{width: '95%'}}>
                <Adsense
                    client={"ca-pub-5171039140785324"}
                    slot={"5605948111"}
                    format={"auto"}
                    style={{display: 'block', textalign: 'center'}}
                />
            </div>);

        const bannerBottom = (
            <div style={{width: '95%'}}>
                <Adsense
                    client={"ca-pub-5171039140785324"}
                    slot={"9667771618"}
                    format={"auto"}
                    style={{display: 'block', textalign: 'center'}}
                />
            </div>);

        return (
            <div className="ContentSpacer fadeIn detailContent card" ref={'content'}>
                <div
                    style={{
                        width: '100%',
                        height: '60vh',
                        backgroundImage: 'url(' + global.api.GetImage(this.state.data.image) + ')'
                    }}
                    className="Cover"
                />

                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    paddingBottom: '25px'
                }}>
                    {shareButton}

                    <div style={{
                        fontSize: "30px",
                        marginTop: "25px",
                        marginBottom: "20px",
                        textAlign: 'left'
                    }}>{this.state.data.title}</div>
                    {bannerTop}
                    <div className={"BodyText"}
                         style={{lineHeight: '32px', fontSize: "18px", textAlign: 'left'}}>

                        {this.state.data.text.split("\n").map(function (item, index) {
                            return (
                                <span key={index}>
                                    {item}
                                    <br/>
                                </span>
                            )
                        })}

                    </div>
                    {shareButton}
                    {bannerBottom}
                </div>
            </div>

        );
    }
}

export default GetCalendar;





// WEBPACK FOOTER //
// ./src/include/GetCalendar.js